import React, { useEffect } from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import About from "../components/home/About";
import AffordableCare from "../components/home/AffordableCare";
import NurseCredentials from "../components/home/NurseCredentials";
import Values from "../components/home/Values";
import Team from "../components/home/Team";
import WhyChoose from "../components/home/WhyChoose";

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us – Moggies & Doggies Veterinary Care";
  }, []);
  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner
          title="About Us"
          subtitle="Passionate Professionals Dedicated to Pet Health & Happiness"
          crumbs={["About Us"]}
        />
        <About />
        <NurseCredentials />
        <AffordableCare />
        <Values />
        <Team showBanner={false} />
        <WhyChoose />
      </main>
      <Footer />
    </div>
  );
};

export default AboutUs;
